export const setUser = (email: string, user_id: any) => {
    (window as any).intercomSettings = {
        email: email,
        user_id: user_id,
        app_id: 'reg4n86n'
    };
};
